module.exports = "<span class=\"radiobutton\"></span><span class=\"radiobutton-text\">{{#if displayHtml}}{{{displayHtml}}}{{else}}{{displayText}}{{/if}}</span>\r\n";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/impl/radioGroup/templates/radioButton.hbs
// module id = 673
// module chunks = 0